import { useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { axDashboardApi } from "./api";

export const useGetAllTabsDashboardData = (tabName: string) => {
  const remoteUtilityId = useRemoteUtilityId();
  return useSmartQuery(
    QueryKeyFactory.module.ax.dashboard.getAllTabsDashboardData(
      tabName,
      remoteUtilityId
    ),
    () => axDashboardApi.getAllTabsDashboardData(tabName, remoteUtilityId),
    {
      enabled: !!tabName && !!remoteUtilityId,
    }
  );
};


  export const useGetFinancialData = (params: {
    remote_utility_id: string;
    date_filter: string;
  }) => {
    return useSmartQuery(
      QueryKeyFactory.module.ax.dashboard.financialData(params),
      () => axDashboardApi.getFinancialData(params)
    );
  };

